import React from "react";
import G from "../libs/Glob.mjs";
import AutoYNField from "./autoFields/AutoYNField.mjs";
import AutoYNAField from "./autoFields/AutoYNAField.mjs";
import AutoRadioFields from "./autoFields/AutoRadioFields.mjs";
import AutoCheckboxField from "./autoFields/AutoCheckboxField.mjs";
import AutoSelectMultiField from "./autoFields/AutoSelectMultiField.mjs";
import AutoSelectField from "./autoFields/AutoSelectField.mjs";
import AutoUnitValueField from "./autoFields/AutoUnitValueField.mjs";
import AutoPercentField from "./autoFields/AutoPercentField.mjs";
import AutoTextField from "./autoFields/AutoTextField.mjs";
import AutoAtecoField from "./autoFields/AutoAtecoField.mjs";
import AutoItemInfoField from "./autoFields/AutoItemInfoField.mjs";
import AutoAbstractField from "./autoFields/AutoAbstractField.mjs";
import AutoGroupField from "./autoFields/AutoGroupField.mjs";
import AutoMultiGroupField from "./autoFields/AutoMultiGroupField.mjs";
import AutoTimeAmountField from "./autoFields/AutoTimeAmountField.mjs";

const prefix = 'AutoFormFields';

const AutoFormFields = class extends React.Component{
	constructor(props) {
		super(props);
		this.uid = G.generateUid(prefix);
		this.renderField = this.renderField.bind(this);
	}

	renderField( fdef, fieldPosition ) {
		const props = {
			key: fieldPosition,
			index: fieldPosition,
			def: fdef,
			formHelper: this.props.helper,
			topHelper: this.props.topHelper
		}
		switch ( fdef.type ) {
			case 'YN': return <AutoYNField {...props} />;
			case 'YNA': return <AutoYNAField {...props} />;
			case 'radio': return <AutoRadioFields {...props} />;
			case 'checkbox': return <AutoCheckboxField {...props} />;
			case 'select': return fdef.multi? <AutoSelectMultiField {...props} /> : <AutoSelectField {...props} />;
			case "UnitValue": return <AutoUnitValueField {...props} />;
			case "percent": return <AutoPercentField {...props} />;
			case 'text': return <AutoTextField {...props} />;
			case 'group': return fdef.multiple ? <AutoMultiGroupField {...props} />: <AutoGroupField {...props} />;
			case 'ateco': return <AutoAtecoField {...props} />;
			case 'iteminfo': return <AutoItemInfoField {...props} />;
			case 'TimeAmount': return <AutoTimeAmountField {...props} />;
			default: return <AutoAbstractField {...props} />;
		}
	}

	render() {
		return(
			<div className={prefix} id={this.uid}>
				{ (this.props.fields || []).map( this.renderField )}
			</div>
		)
	}
}

export default AutoFormFields;